import React, { useEffect } from 'react'
import Navbar from '../../Components/Navbar'
import { useDispatch, useSelector } from 'react-redux';
import { useNavigationHook } from '../../Hooks/useNavigationHook';
import axios from 'axios';
import { RootState } from '../../Store/store';
import { setStatisticsData } from '../../Store/slices/settingsSlice';
import { Card } from '@mui/material';
import OutlinedCard from '../Blogs/components/CardComponent';

export default function Homepage() {
    const {
        accessToken,
        refreshToken,
        UID,
    } = useSelector((state: RootState) => state.auth.value);
    const { statisticsData } = useSelector((state: RootState) => state.settings.value);
    const {
        navigateTo
    } = useNavigationHook();

    const dispatch = useDispatch();

    const fetchStatistics = async () => {
        const BASE_URL = 'https://api.eatwellmama.com'
        await axios.get(
            BASE_URL + '/api/admin/get-statistics',
            {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
            }
        ).then((response) => {
            console.log(response.data);
            dispatch(setStatisticsData(response.data.data));

        }).catch((error) => {
            console.log(error);
        }
        );
    };

    const checkAuth = async () => {
        if (accessToken === '' || refreshToken === '' || UID === '') {
            navigateTo('/');
        } else {
            await fetchStatistics();
        }
    };

    useEffect(() => {
        checkAuth();
    }, []);

    return (
        <div>
            <Navbar />
            {
                statisticsData !== null ? (
                    <div className='grid grid-cols-4'>
                        <OutlinedCard title="Total Users Count" content={statisticsData.userCount} onPress={() => navigateTo('/settings')} />
                        <OutlinedCard title="Total Recipes" content={statisticsData.recipeCount} onPress={() => navigateTo('/recipes')} />
                        <OutlinedCard title="Total Blogs" content={statisticsData.blogCount} onPress={() => navigateTo('/blogs')} />
                        <OutlinedCard title="Total QnA" content={statisticsData.qnaCount} onPress={() => navigateTo('/qna')} />
                        <OutlinedCard title="Total Tags" content={statisticsData.tagsCount} onPress={() => navigateTo('/tags')} />
                        <OutlinedCard title="Total Users on Firebase" content={statisticsData.userCountFromFirebase} onPress={() => navigateTo('/settings')} />
                        <OutlinedCard title="Total Guest Users" content={statisticsData.guestUserCount} onPress={() => navigateTo('/settings')} />
                        <OutlinedCard title="Total Guest to Normal Users" content={statisticsData.guestToNormalUserCount} onPress={() => navigateTo('/settings')} />
                    </div>
                ) : (
                    <div>Loading...</div>
                )
            }
        </div>
    )
}
